const domainsByLocale = {
    'ca-ES': 'lacolmenaquedicesi.ca',
    'de-CH': 'marktschwaermer.ch',
    'de-DE': 'marktschwaermer.de',
    'es-ES': 'lacolmenaquedicesi.es',
    'fr-BE': 'laruchequiditoui.be',
    'fr-CH': 'ruchequiditoui.ch',
    'fr-FR': 'laruchequiditoui.fr',
    'it-IT': 'alvearechedicesi.it',
    'nl-BE': 'boerenenburen.be',
    'nl-NL': 'boerenenburen.nl',
};

export function getDomain(longLocale) {
    return domainsByLocale[longLocale] || domainsByLocale['fr-FR'];
}

export function getCanonicalUrl(longLocale, page) {
    return `https://${getDomain(longLocale)}/${longLocale}/${page}`;
}

export function getTerritoryBaseUrl(longLocale) {
    return `https://${getDomain(longLocale)}/${longLocale}`;
}
